import TeamsEmptyState from 'pages/teams/emptyState/emptyState.view';
import { useState } from 'react';
import CreateTeamDrawer from 'pages/teams/createTeamDrawer/createTeamDrawer.view';
import TeamsViewHeader from 'pages/teams/teamsList/TeamsViewHeader/teamsViewHeader.view';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import TeamsGridView from 'pages/teams/teamsList/teamsGrid.view';
import { SettingsMain } from 'components/common/styledComponents/settings.style';
import selectors from 'store/selectors';
import { Stack } from '@mui/material';

function TeamsDashboard(props) {
  const [open, setOpen] = useState(false);
  const [selectedEditTeam, setSelectedEditTeam] = useState(null);

  const teams = useSelector(selectors.getTeams);

  const toggleDrawer = (callback) => {
    setOpen(!open);
    callback && callback();
    setSelectedEditTeam(null);
  };
  const handleEditTeam = (data) => {
    setSelectedEditTeam(data);
    setOpen(true);
  };
  return (
    <Stack>
      <TeamsViewHeader toggleDrawer={toggleDrawer} />
      <CreateTeamDrawer
        heading="Add Team"
        open={open}
        onClose={toggleDrawer}
        selectedEditTeam={selectedEditTeam}
      />
      {isEmpty(teams) ? (
        <TeamsEmptyState toggleDrawer={toggleDrawer} />
      ) : (
        <TeamsGridView
          data={teams}
          toggleDrawer={toggleDrawer}
          taskActionDropdownProps={{ handleEditTeam }}
        />
      )}
    </Stack>
  );
}

export default TeamsDashboard;
